import _extends from "@babel/runtime/helpers/extends";
import { setStorage } from '../../storage';
/**
 *
 * Looking at the object passed in, it sets campaign params in session storage to be retrieved later
 * by getCampaignParams. If both pk and utm params are passed in, pk params will overwrite utm params.
 * It will ignore any non-campaign params.
 *
 *  Keys it looks for:
 *    piwik: [`pk_source`, `pk_campaign`, `pk_medium`, `pk_content`, `pk_kwd`]
 *     Google Analytics: [`utm_source`, `utm_campaign`, `utm_medium`, `utm_content`, `utm_term`]
 *
 * ```js
 * import queryString from 'query-string';
 * import { saveCampaignParams } from '@minerva-analytics/pantheon';
 *
 *
 * const parsedParams = queryString.parse(routing.location.search);
 *
 * saveCampaignParams(parsedParams);
 * ```
 *
 * @param {object} urlParams representation of all of the campaign params an their values to save in session Storage
 * * @return {object} object representation of the params that were saved.
 *
 */

export var paramsToSave = {
  piwik: {
    pk_source: "campaign_source",
    pk_campaign: "campaign_name",
    pk_medium: "campaign_medium",
    pk_content: "campaign_content",
    pk_kwd: "campaign_keyword"
  },
  ga: {
    utm_source: "campaign_source",
    utm_campaign: "campaign_name",
    utm_medium: "campaign_medium",
    utm_content: "campaign_content",
    utm_term: "campaign_keyword"
  }
};
export var saveParamsLocally = function saveParamsLocally(paramMap, urlParams) {
  var savedParams = {};
  Object.keys(paramMap).forEach(function (param) {
    if (urlParams[param]) {
      setStorage({
        key: paramMap[param],
        value: urlParams[param],
        session: true
      });
      savedParams[paramMap[param]] = urlParams[param];
    }
  });
  return savedParams;
};
export var saveCampaignParams = function saveCampaignParams(urlParams) {
  var savedGA = saveParamsLocally(paramsToSave.ga, urlParams);
  var savedPiwik = saveParamsLocally(paramsToSave.piwik, urlParams);
  return _extends({}, savedGA, savedPiwik);
};
export default saveCampaignParams;